<template>
  <div id="join-classroom">
    <b-field :type="formsMngmnt.code_type" :message="formsMngmnt.code_message">
      <b-input type="text" v-model="code"  id="codeField" placeholder="código"  ref="codeField" required > </b-input>
    </b-field>
    <div class="anwer">
      <div v-if="inscriptionStatus === 'ok'" class="has-text-success">
        Estupendo. Ya te has inscrito!
      </div>
      <div v-if="inscriptionStatus === 'error'" class="has-text-danger">
        código no valido. ¿Estas seguro de que lo has copiado bien?
      </div>
    </div>

    <div class="control" v-if="inscriptionStatus !== 'ok'">
      <button  class="btn btn-bg-colored btn-no-margin" v-on:click="addMeToClassroom">inscribir</button>
    </div>

  </div>
</template>
<script>
export default {
  name: 'JoinClassroom',
  data: () => ({
    formsMngmnt: {
      code_message: '',
      code_type: ''
    },
    code: '',
    isInscribed: false,
    inscriptionStatus: ''
  }),
  methods: {
    addMeToClassroom () {
      this.$store.dispatch('user/addMeToClassroom', this.code)
        .then(() => {
          this.isInscribed = true
          this.inscriptionStatus = 'ok'
          this.formsMngmnt.code_type = 'is-success'
          this.code = ''
          this.$emit('success')
        })
        .catch((error) => {
          this.inscriptionStatus = 'error'
          this.formsMngmnt.code_type = 'is-error'
          console.log(error)
        })
    }
  }

}
</script>
<style lang="less" scoped>
@import (reference) "../../assets/styles/main.less";

#join-classroom{
  max-width:500px;
  #codeField{
    max-width:10em;
  }
}

.has-text-success, .has-text-danger {
  .font-code;
}
</style>



// WEBPACK FOOTER //
// src/components/User/JoinClassroom.vue